import { memo } from "react";
import * as PR from "../../prime-react/index";
import { dateTimeFormat, processHtmlLinks, trimFileName } from "../../utils/reuse";

const MessageSend = memo(({ message, index, userSend, senderImageSrc, fetchFileDetails }) => {
    const { senderID, content, attachment, createdAt, senderUserImage, senderUserName } = message ?? {};

    const renderAttachment = () => {
        if (attachment) {
            const file = JSON.parse(attachment);
            return (
                <PR.Button
                    key={file.key}
                    icon="pi pi-file"
                    label={trimFileName(file.name)}
                    className={`file-download-button ${!content ? 'report-file' : ''}`}
                    onClick={() => fetchFileDetails(file.key, file.name)}
                />
            );
        }
        return null;
    };
    const renderSenderImage = (senderUserImage, userSend) => {
        const tooltipLabel = senderUserName || "User";

        if (senderUserImage) {
            return (
                <span title={tooltipLabel}>
                    <PR.Image src={senderImageSrc || userSend} alt={tooltipLabel} className="chat-image group-name-icon" />
                </span>
            );
        } else {
            return (
                <span title={tooltipLabel}>
                    <PR.Image src={userSend} alt={tooltipLabel} className="chat-image" />
                </span>
            );
        }
    };

    return (
        <div className="messages-wrapper send" key={senderID + index}>
            {content && (
                <div className="box">
                    <div
                        className="message send"
                        dangerouslySetInnerHTML={{ __html: processHtmlLinks(content) }}
                    />
                    {renderSenderImage(senderUserImage, userSend)}
                </div>
            )}

            <div className="attachment-file">
                {renderAttachment()}
                {!content && renderSenderImage(senderUserImage, userSend)}
            </div>

            <span className="time">{dateTimeFormat(createdAt)}</span>
        </div>
    );
});

export default MessageSend;
